import script from "./About.vue?vue&type=script&setup=true&lang=ts"
export * from "./About.vue?vue&type=script&setup=true&lang=ts"

import "./About.vue?vue&type=style&index=0&id=495bd0a4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495bd0a4"]])

export default __exports__